import _ from 'lodash';
import { jwtDecode } from 'jwt-decode';

/** `otto_access.roles` of the Keycloak token contains systemAdmin. Gates the
 *  CSV structure import — deliberately not granted to globalAdmin. */
export const isSystemAdminToken = (token: string | undefined | null): boolean => {
    if (!token) return false;
    try {
        const decoded = jwtDecode<Record<string, unknown>>(token);
        const roles = _.get(decoded, 'otto_access.roles', []) as string[];
        return roles.includes('systemAdmin');
    } catch {
        return false;
    }
};
